<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div>
    <v-card>
      <v-card-title>
          <div class="headline">Nature of Loss 1 Details</div>
        </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <message :messages="messages" v-if="!clmNol2Dialog && !listMessage"></message>
        <v-container fluid grid-list-lg>
          <form data-vv-scope="clmNol1Form">
            <v-layout row wrap>
              <v-flex xs6 v-if="newClmNol1">
                  <v-text-field data-vv-scope="clmNol1Form" :label="labels.nol1" v-model="clmNol1Form.nol1" :error-messages="errors.collect('clmNol1Form.nol1')" data-vv-name="nol1" :data-vv-as="labels.nol1" v-validate="'required|param|max:2'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.nol1}}</v-subheader>
                  <div class="title">{{clmNol1Form.nol1}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field data-vv-scope="clmNol1Form" :label="labels.nol1ShortDesc" v-model="clmNol1Form.nol1ShortDesc" :error-messages="errors.collect('clmNol1Form.nol1ShortDesc')" data-vv-name="nol1ShortDesc" :data-vv-as="labels.nol1ShortDesc" v-validate="'required|entry|max:10'"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field data-vv-scope="clmNol1Form" :label="labels.nol1LongDesc" v-model="clmNol1Form.nol1LongDesc" :error-messages="errors.collect('clmNol1Form.nol1LongDesc')" data-vv-name="nol1LongDesc" :data-vv-as="labels.nol1LongDesc" v-validate="'required|entry|max:40'"></v-text-field>
              </v-flex>
            </v-layout>
          </form>
        </v-container>
      </v-card-text>
      <v-flex xs12 row warp>
        <v-btn color="primary" type="submit" @click.prevent="doSaveClmNol1">
          {{newClmNol1 ? 'Save Nature of Loss 1' : 'Update Nature of Loss 1'}}
          <v-icon right>{{newClmNol1 ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
    <v-divider></v-divider>
    <v-card v-if="!newClmNol1">
      <message :messages="messages" v-if="listMessage"></message>
      <v-card-title>
        <div class="headline">Nature of Loss 2 Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="nol2" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.nol2 }}</td>
          <td class="text-xs-left">{{ props.item.nol2Desc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReviewClmNol2(nol1, props.item.nol2)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-dialog v-model="clmNol2Dialog" max-width="900px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">{{ labels.formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
              <v-container grid-list-md>
              <form data-vv-scope="clmNol2Form">
                <v-layout wrap>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{labels.nol1}}</v-subheader>
                    <div class="title">{{clmNol2Form.nol1}}</div>
                  </v-flex>
                  <v-flex xs6 v-if="newClmNol2">
                    <v-text-field data-vv-scope="clmNol2Form" :label="labels.nol2" v-model="clmNol2Form.nol2" :error-messages="errors.collect('clmNol2Form.nol2')" data-vv-name="nol2" :data-vv-as="labels.nol2" v-validate="'required|param|max:2'"></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-subheader class="queryLabel">{{labels.nol2}}</v-subheader>
                    <div class="title">{{clmNol2Form.nol2}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field data-vv-scope="clmNol2Form" :label="labels.nol2Desc" v-model="clmNol2Form.nol2Desc" :error-messages="errors.collect('clmNol2Form.nol2Desc')" data-vv-name="nol2Desc" :data-vv-as="labels.nol2Desc" v-validate="'required|entry|max:40'"></v-text-field>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12>
        <v-btn color="primary" dark class="mb-2" @click="doNewClmNol2">New Nature of Loss 2</v-btn>
      </v-flex>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Reserve Categoty? ({{deleteClmNol2}})
      </confirm>
    </v-card>
  </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      breadcrumb: [],
      title: 'Review Nature of Loss',
      labels: {
        nol1: 'Nature of Loss 1*',
        nol1ShortDesc: 'Short Description*',
        nol1LongDesc: 'Long Description*',
        nol2: 'Nature of Loss 2*',
        nol2Desc: 'Description*'
      },
      clmNol1Form: {
        nol1: null,
        nol1ShortDesc: null,
        nol1LongDesc: null
      },
      headers: [
        { text: 'Nature of Loss 2', value: 'nol2' },
        { text: 'Description', value: 'nol2Desc' },
        TableConst.tableActionHeader
      ],
      clmNol2Form: {
        nol1: this.$route.params.nol1,
        nol2: null,
        nol2Desc: null
      },
      clmNol2Dialog: false,
      newClmNol2: false,
      newClmNol1: false,
      loading: false,
      promptRemove: false,
      selectedClmNol2: undefined,
      deleteClmNol2: '',
      listMessage: false
    }
  },
  methods: {
    async doFetchGeneral() {
      const apiURI = this.$store.state.claimParam.menu.getClmNol1
      const expand = {
        nol1: this.nol1
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.clmNol1Form.nol1 = data.nol1.nol1
          this.clmNol1Form.nol1ShortDesc = data.nol1.nol1ShortDesc
          this.clmNol1Form.nol1LongDesc = data.nol1.nol1LongDesc
        }
      }
    },
    async doFetchClmNol2() {
      this.loading = true
      const apiURI = this.$store.state.claimParam.menu.getClmNOL2List
      if (apiURI) {
        try {
          const expand = {
            nol1: this.nol1
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((ClmNol2) => {
              const convertClmnol2 = {
                nol1: ClmNol2.nol1,
                nol2: ClmNol2.nol2,
                nol2Desc: ClmNol2.nol2Desc
              }
              this.items.push(convertClmnol2)
            })
            this.loading = false
          } else {
            this.loading = false
          }
        } catch (error) {
          this.loading = false
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.loading = false
        this.errorMessage('Invalid API Url')
      }
    },
    async doSaveClmNol1() {
      this.resetMessages()
      this.$validator.validateAll('clmNol1Form').then(result => {
        if (result) {
          if (this.newClmNol1) {
            this.doNewClmNol1()
          } else {
            this.doUpdateClmNol1()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doNewClmNol1() {
      const apiURI = this.$store.state.claimParam.menu.createClmNol1
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            nol1: this.clmNol1Form.nol1,
            nol1ShortDesc: this.clmNol1Form.nol1ShortDesc,
            nol1LongDesc: this.clmNol1Form.nol1LongDesc
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'clmNol' })
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdateClmNol1() {
      const apiURI = this.$store.state.claimParam.menu.updateClmNol1
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            nol1: this.nol1,
            nol1ShortDesc: this.clmNol1Form.nol1ShortDesc,
            nol1LongDesc: this.clmNol1Form.nol1LongDesc
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doReviewClmNol2(nol1, nol2) {
      const apiURI = this.$store.state.claimParam.menu.getClmNol2
      const expand = {
        nol1,
        nol2
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.clmNol2Form.nol1 = data.nol2.nol1
          this.clmNol2Form.nol2 = data.nol2.nol2
          this.clmNol2Form.nol2Desc = data.nol2.nol2Desc
        }
        this.clmNol2Dialog = true
      }
    },
    doNewClmNol2() {
      this.clmNol2Dialog = true
      this.newClmNol2 = true
      this.initForm()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll('clmNol2Form').then(result => {
        if (result) {
          if (this.newClmNol2) {
            this.doCreateClmNol2()
          } else {
            this.doUpdateClmNol2()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateClmNol2() {
      const apiURI = this.$store.state.claimParam.menu.createClmNol2
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            nol1: this.clmNol1Form.nol1,
            nol2: this.clmNol2Form.nol2,
            nol2Desc: this.clmNol2Form.nol2Desc
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdateClmNol2() {
      const apiURI = this.$store.state.claimParam.menu.updateClmNol2
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            nol1: this.clmNol2Form.nol1,
            nol2: this.clmNol2Form.nol2,
            nol2Desc: this.clmNol2Form.nol2Desc
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doClose() {
      this.clmNol2Dialog = false
      this.newClmNol2 = false
      this.initForm()
    },
    initForm() {
      this.resetValidator()
      this.resetMessages()
      this.clmNol2Form.nol2 = null
      this.clmNol2Form.nol2Desc = null
      this.doFetchClmNol2()
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedClmNol2 = data
        this.deleteClmNol2 = data.nol2 + ' - ' + data.nol2Desc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmNOL2
      if (apiURI) {
        this.loading = true
        const expand = {
          nol1: this.selectedClmNol2.nol1,
          nol2: this.selectedClmNol2.nol2
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.doClose()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.listMessage = true
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('clmNol')
    this.breadcrumb.push({
      name: 'clmNolReview',
      text: this.title
    })
    if (this.nol1 === 'new') {
      this.newClmNol1 = true
    } else {
      this.newClmNol1 = false
      this.doFetchGeneral()
      this.doFetchClmNol2()
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    nol1() {
      return this.$route.params.nol1
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
